import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import Form from '../components/Form'
import LoginAlert from '../components/LoginAlert'
import Alert from '../components/Alert'
import { ThemeContext } from '../providers/ThemeProvider'
import { useStateValue } from '../providers/StateProvider'
import ModeButton from '../components/ModeButton'
import Card from '../components/Card'

const Main = styled.div`
  min-height: 100vh;
  max-width: 1400px;
  margin: 0 auto;

	h1 {
  	color: #888;
  	margin: 32px 16px;
    font-size: 2em;
  }
`

const FormBox = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 400px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

const Cards = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`

const Error = styled.p`
  background-color: #000;
  color: #888;
  font-size: 1.25em;
  padding: 16px;
  border-radius: 4px;
  margin-left: 16px;
`

const Home = (props) => {
  const [input, setInput] = useState('')
  const { addCharacters, characters, seenAlert, seenLoginAlert } = useStateValue()

  const handleClick = (e) => {
    e.preventDefault()
    getCharacters()
  }

  const getCharacters = () => {
    //Marvel API: https://developer.marvel.com/
    const url = `https://gateway.marvel.com:443/v1/public/characters?nameStartsWith=${input}&limit=24&apikey=541f922513aa3b4e06a535f280c5194b`
    fetch(url)
      .then(response => response.json())
      .then (data => {
        addCharacters(data)
      })
      .catch(error => {
          console.log('it broke')
      })
  }

  const { mode } = useContext(ThemeContext)
  const isEvil1 = ((mode === 'hydra') && (seenAlert <= 1))
  const isEvil2 = (mode === 'hydra')
  const isNew = (seenLoginAlert <=1)

  return (
    <Main>
      {isNew ? <LoginAlert /> : null}
      {isEvil1 ? <Alert /> : null}
      {isEvil2 ? <h1>HYDRA Database</h1> : <h1>S.H.I.E.L.D. Database</h1>}
      <FormBox>
        <Form
          type='textInput'
          instructions='Enter Subject Name'
          onChange={ e => setInput(e.target.value) }
          onClick = { handleClick }
        />
        <ModeButton />
      </FormBox>
      <Cards>
        {(characters.length === 0) ?
          <Error>No records found.</Error>
          : characters.map( (character, index) =>
            <Card
              key={ index }
              id={ character.id }
              img={ character.img }
              alt={ character.name }
              name={ character.name }
            />
        )}
      </Cards>
    </Main>
  )
}

export default Home
